//Companies House UK
///search/companies
export const COMPANIES_HOUSE_UK_SEARCH_COMPANIES =
  "COMPANIES_HOUSE_UK_SEARCH_COMPANIES";
export const COMPANIES_HOUSE_UK_SEARCH_COMPANIES_SUCCESS =
  "COMPANIES_HOUSE_UK_SEARCH_COMPANIES_SUCCESS";
export const COMPANIES_HOUSE_UK_SEARCH_COMPANIES_FAILURE =
  "COMPANIES_HOUSE_UK_SEARCH_COMPANIES_FAILURE";

///extcompanieshouse/company/filinghistory/list/
export const COMPANIES_HOUSE_UK_GET_FILING_HISTORY =
  "COMPANIES_HOUSE_UK_GET_FILING_HISTORY";
export const COMPANIES_HOUSE_UK_GET_FILING_HISTORY_SUCCESS =
  "COMPANIES_HOUSE_UK_GET_FILING_HISTORY_SUCCESS";
export const COMPANIES_HOUSE_UK_GET_FILING_HISTORY_FAILURE =
  "COMPANIES_HOUSE_UK_GET_FILING_HISTORY_FAILURE";

///customer/locate/searchbusiness
export const COMPANIES_HOUSE_UK_GET_OFFICERS =
  "COMPANIES_HOUSE_UK_GET_OFFICERS";
export const COMPANIES_HOUSE_UK_GET_OFFICERS_SUCCESS =
  "COMPANIES_HOUSE_UK_GET_OFFICERS_SUCCESS";
export const COMPANIES_HOUSE_UK_GET_OFFICERS_FAILURE =
  "COMPANIES_HOUSE_UK_GET_OFFICERS_FAILURE";
